import { type FunctionalComponent, h} from '@stencil/core';
import {DashboardGenericTile} from '../dashboard-generic-tile/dashboard-generic-tile';
import type {IDashboardDesktopView} from '../dashboard-views/dashboard-desktop-view';
import type {SearchProduct} from '../../../../../../api/model/response/documents/public/Product';
import type {SearchApiDocument} from '../../../../../../api/model/response/documents/SearchResult';
import {DashboardTileSkeleton} from './dashboard-tile-skeleton';

interface IDashboardDocumentsTileProp extends Pick<IDashboardDesktopView, 'labelProvider' | 'strategies' | 'query' | 'rtl' | 'country' | 'language' | 'lazyLoadImages' | 'sectionsData'> {
    doc: SearchApiDocument[] | SearchProduct[];
    title: string;
    customValueClass?: string;
    targetTab: string;
    tabCount: number;
    section: string;
    privateCard?: boolean;
    showPlaceholder?: boolean;
    limitResults?: boolean;
    sectionIsReady?: boolean;
    noContent?: boolean;
    sectionIsLoading?: boolean;
    useSkeleton?: boolean;
    span?: number;
    horizontalView?: boolean;
    mobileView?: boolean;
}


export const DashboardDocumentsTile: FunctionalComponent<IDashboardDocumentsTileProp> = (props) => {
    const { labelProvider, doc, title, customValueClass, targetTab, tabCount, strategies, section, privateCard, showPlaceholder, query, rtl, country, language, lazyLoadImages, sectionIsLoading, useSkeleton, mobileView } = props;
    const showSubTitle = privateCard == null ? true : privateCard;

    if (sectionIsLoading && useSkeleton) {
      return <DashboardTileSkeleton picturePlaceholder={true} />;
    }

    if (!doc || doc.length === 0) {
      return null;
    }

    const items = doc.map((el, index) => {
        if (el.source === 'community_articles' || el.source === 'community_forum') {
          const thumbnailUrl = typeof el.thumbnailUrl === 'object' && el.thumbnailUrl?.href
            ? el.thumbnailUrl.href
            : el.thumbnailUrl;
          return (
            <dashboard-community-item
              rtl={rtl}
              labelProvider={(e, f) => labelProvider(e, f)}
              doc={{ ...el, thumbnailUrl }}
              index={index}
              strategies={strategies}
              section={section}
              showPlaceholder={showPlaceholder}
              country={country}
              language={language}
            />
          );
        }
        return (
          <dashboard-document-item
            rtl={rtl}
            labelProvider={(e, f) => labelProvider(e, f)}
            doc={el}
            index={index}
            strategies={strategies}
            section={section}
            showPlaceholder={showPlaceholder}
            lazy-Load-images={lazyLoadImages}
          />
        );
    });

    return (
      doc && doc.length > 0 &&
        <DashboardGenericTile
          labelProvider={(e, f) => labelProvider(e, f)}
          title={title}
          customValueClass={customValueClass}
          targetTab={targetTab}
          tabCount={tabCount}
          subTitle={showSubTitle}
          itemCount={doc.length}
          term={query}
          mobileView={mobileView}
        >
          {items}
        </DashboardGenericTile>
    );
};
